var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"v-view-primary"},[_c('OrganismTheHeader'),_c('section',{staticClass:"v-edition-section"},[_c('OrganismEditionSectionNavigation'),_c('OrganismEditionSectionContent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }